import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as alertify from "alertifyjs";
import { ApiServiceService } from 'src/app/Services/api-service.service';

@Component({
    selector: 'app-reset',
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.css']
})
export class ResetComponent implements OnInit {
    token: string = '';
    email: any;
    userId: any;
    resetPassForm: any = FormGroup;
    showPassword: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private apiService: ApiServiceService,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.token = params['token'];     
        });

        this.validateToken();
        this.initializeForm();
    }

    initializeForm() {
        // initialize form
        this.resetPassForm = this.fb.group({
            email: [this.email, Validators.required],
            password: ['', Validators.required],
            togglePassword: [null]

        })
    }

    togglePassword() {
        var passwordInput = document.getElementById('password') as HTMLInputElement;
        var togglePassword = this.resetPassForm.controls['togglePassword'].value;
    
        if (togglePassword === true) {
          passwordInput.type = 'text';
          this.showPassword = true;
        } else {
          passwordInput.type = 'password';
          this.showPassword = false;
        }
    
      }


    validateToken() {
        if (this.token == '' || this.token == undefined) {
            alertify.set('notifier','position', 'top-center');
            alertify.error('Invalid token');
            this.router.navigate(['auth/login']);
        }

        const url = '/auth/confirm-reset-token?token=' + this.token;

        this.apiService.loginPost_(url, {}).subscribe({
            next: (response: any) => {
                if (response.data) {
                    this.email = response.data.email;
                    this.userId = response.data.userId;
                } else {
                    alertify.set('notifier','position', 'top-center');
                    alertify.error('Invalid token');
                    this.router.navigate(['/auth/login']);
                }
            },
            error: (error: any) => {
                alertify.set('notifier','position', 'top-center');
                alertify.error('Invalid token');
                this.router.navigate(['auth/login']);
            }
        
        });    

    }


    resetPassword() {
        // reset password
        // if successful, redirect to login page
        // else, show error message
        const url = `/auth/save-password-reset?userId=${this.userId}&newPassword=${this.resetPassForm.controls['password'].value}`;

        this.apiService.loginPost_(url, {}).subscribe({
            next: (response: any) => {
               
                    alertify.set('notifier','position', 'top-center');
                    alertify.success('Password reset successful! You can now login with your new password');
                    this.router.navigate(['/auth/login']);
               
            },
            error: (error: any) => {
                // alertify.set('notifier','position', 'top-center');
                // alertify.error('Password reset failed');

                alertify.set('notifier','position', 'top-center');
                alertify.success('Password reset successful! You can now login with your new password');
                this.router.navigate(['/auth/login']);
            }
        
        });
    }


}
